import {fetchPost,fetchGet} from './http'
// let host = 'http://192.168.3.66:8088' 
let host = 'http://1.95.5.134:8088' 
// post
// 登录
export const selectUser = params => { return fetchPost(`${host}/shopAdmin/selectShopUser`, params)}
// 客户端订货单查询 
export const selectAllOrder = params => { return fetchGet(`${host}/order/selectAllOrder`, {params:params})}
//   客户端订单搜索
export const ordersearch = params => { return fetchPost(`${host}/order/searchCondition`, params)}
//  新增订货单
export const addOrder = params => { return fetchPost(`${host}/order/addOrder`, params)}
// 查询全部设备 
export const list = params => { return fetchGet(`${host}/device/list`, {params:params})}
// 删除订货单 
export const deleteOrder = params => { return fetchGet(`${host}/order/deleteOrders`, {params:params})}
// 查看订货单详情  
export const selectOrderById = params => { return fetchGet(`${host}/order/selectOrderById`, {params:params})}
//   客户端确认收货更改订单状态
export const updateOrderState = params => { return fetchGet(`${host}/order/updateOrderState`, {params:params})}
//  客户端设备查询数量
export const queryCount = params => { return fetchPost(`${host}/deviceDetail/queryCount`, params)}
//   客戶端库存管理搜索
export const stocksearch = params => { return fetchPost(`${host}/deviceDetail/searchCondition`, params)}
// 账号管理 /
export const selectNumber = params => { return fetchGet(`${host}/shopAdmin/selectNumber`, {params:params})}
// 修改密码 /
export const updatePassword = params => { return fetchPost(`${host}/shopAdmin/updatePassword`, params)}
// 修改地址 /
export const updateAddress = params => { return fetchGet(`${host}/shopAdmin/updateAddress`, {params:params})}
// 查询产品列表 
export const getproduct = params => { return fetchGet(`${host}/product/selectList`, {params:params})}
// 车辆信息录入 
export const carMessage = params => { return fetchPost(`${host}/carMessage/addCarMessage`, params)}
// 文件上传 
export const uploadOssFile = params => { return fetchPost(`${host}/file/uploadOssFile`, params)}
// 文件删除 
export const remove = params => { return fetchGet(`${host}/file/remove`, {params:params})}
// 自定义配置信息 
export const customizeinfo = params => { return fetchGet(`${host}/product/custom-info/selectList`, {params:params})}
// 保存产品信息 
export const saveDrafts = params => { return fetchPost(`${host}/carMessage/saveDrafts`, params)}
// 保存安装信息 
export const saveFacility = params => { return fetchPost(`${host}/carMessage/saveFacility`, params)}
// 安装信息校验接口  
export const verifyFacility = params => { return fetchPost(`${host}/carMessage/verifyFacility`, params)}
// 编辑账户信息 
export const updateAccountMsg = params => { return fetchPost(`${host}/accountManagement/updateAccountMsg`, params)}
// 查询销售单列表 
export const getselllist = params => { return fetchGet(`${host}/carMessage/list`, {params:params})}
// 查询保险详情 
export const getsafedetail = params => { return fetchGet(`${host}/carMessage/get`, {params:params})}
// 取消订单（待核保） 
export const cancelorder = params => { return fetchGet(`${host}/carMessage/cancel`, {params:params})}
// 申请作废  
export const applyrevoke = params => { return fetchGet(`${host}/carMessage/audit-revoke`, {params:params})}
// 转草稿 
export const transfer2draft = params => { return fetchGet(`${host}/carMessage/transfer2draft`, {params:params})}
// 草稿箱删除 
export const deletedraft = params => { return fetchGet(`${host}/carMessage/deleteDrafts`, {params:params})}
// 草稿箱查询  
export const draftsQuery = params => { return fetchGet(`${host}/carMessage/draftsQuery`, {params:params})}
// 重新提交作废申请  
export const afreshSubmit = params => { return fetchGet(`${host}/carMessage/afreshSubmit`, {params:params})}
// 试算保费  
export const trialPremium = params => { return fetchPost(`${host}/product/trialPremium`, params)}
// 待支付  
export const advancepayment = params => { return fetchGet(`${host}/carMessage/advance-payment`, {params:params})}
// 支付  
export const paymentgo = params => { return fetchGet(`${host}/carMessage/payment`, {params:params})}
// 获取交易号  
export const tradeno = params => { return fetchPost(`${host}/accountManagement/trade-no`, params)}
// 账单统计

export const saleStatistics = params => { return fetchGet(`${host}/carMessage/saleBillStatisticsByShop`, {params:params})}
// 账单明细查 
export const saleDetailStatistics = params => { return fetchGet(`${host}/carMessage/saleDetailStatistics`, {params:params})}
// 返回上一部 
export const deleteCode = params => { return fetchGet(`${host}/carMessage/deleteCode`, {params:params})}
// 库存明细  
export const clientInventoryDetail = params => { return fetchGet(`${host}/deviceDetail/clientInventoryDetail`, {params:params})}
export const clientInventoryDetail1 = params => { return fetchGet(`${host}/deviceDetail/clientInventoryDetail1`, {params:params})}
// 申请退货
export const backApply = params => { return fetchPost(`${host}/backOrder/backApply`, params)}
// 退货单列表  
export const backOrderList = params => { return fetchGet(`${host}/backOrder/backOrderList`, {params:params})}
// 退货单详情  
export const backOrderDetails = params => { return fetchGet(`${host}/backOrder/backOrderDetails`, {params:params})}
// 续费 
export const renew = params => { return fetchGet(`${host}/carMessage/renew`, {params:params})}
// 查询产品绑定的设备 
export const getdevices = params => { return fetchGet(`${host}/product/devices`, {params:params})}
// 核保失败后的产品带不带设备  
export const queryShopProDev = params => { return fetchGet(`${host}/carMessage/queryShopProDev`, {params:params})}
// 查询订货单上次的收货人手机号  
export const selectPhoneAndName = params => { return fetchGet(`${host}/order/selectPhoneAndName`, {params:params})}
// 
export const isCharge = params => { return fetchGet(`${host}/product/isCharge`, {params:params})}
// 操作日志
export const recordlistlog = params => { return fetchGet(`${host}/record/list`, {params:params})}